import type { ButtonProps, PolymorphicComponentProps } from '@mantine/core';
import { ActionIcon, Button, Group, Menu, rem, Tooltip, useMantineTheme } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import type { ReactNode } from 'react';

export function SplitButton({
  size,
  variant,
  buttonChildren,
  mainTooltip,
  disabled,
  menuChildren,
  menuTooltip,
  buttonProps,
}: {
  size?: string;
  variant?: string;
  buttonChildren: ReactNode;
  mainTooltip?: string;
  disabled?: boolean;
  menuChildren: ReactNode;
  menuTooltip?: string;
  buttonProps?: PolymorphicComponentProps<'button', ButtonProps>;
}) {
  const theme = useMantineTheme();

  return (
    <Group
      wrap="nowrap"
      gap={variant === 'default' ? 0 : 1}
    >
      <Tooltip
        disabled={mainTooltip === undefined}
        label={mainTooltip || ''}
      >
        <Button
          size={size}
          {...buttonProps}
          variant={variant || 'filled'}
          disabled={disabled}
          className={`rounded-r-none ${buttonProps?.className || ''}`}
        >
          {buttonChildren}
        </Button>
      </Tooltip>
      <Menu
        transitionProps={{ transition: 'pop' }}
        position="bottom-end"
        withinPortal
      >
        <Tooltip
          disabled={menuTooltip === undefined}
          label={menuTooltip || ''}
        >
          <Menu.Target>
            <ActionIcon
              disabled={disabled}
              variant={variant || 'filled'}
              color={disabled ? 'gray' : buttonProps?.color || theme.primaryColor}
              size={
                size === 'xs' ? 30
                : size === 'compact-sm' ?
                  26
                : 32
              }
              className={`rounded-bl-none rounded-br-md rounded-tl-none rounded-tr-md border border-l-0 ${buttonProps?.className || ''}`}
            >
              <IconChevronDown
                style={{ width: rem(16), height: rem(16) }}
                stroke={1.5}
              />
            </ActionIcon>
          </Menu.Target>
        </Tooltip>

        <Menu.Dropdown>{menuChildren}</Menu.Dropdown>
      </Menu>
    </Group>
  );
}
